import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	successTitle: {
		id: 'servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.success-title',
		defaultMessage: `{feature, select,
            service_request {Service request management}
            incident_management {Incident management}
            problem_management {Problem management}
            change_management {Change management}
            post_incident_review {Post-incident reviews}
            other {unknown}
        } {value, select, false {disabled} true {enabled} other {}}`,
		description: 'Title text of success flag',
	},
	successEnableDescription: {
		id: 'servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.success-enable-description',
		defaultMessage: 'Add request types to start using this category.',
		description: 'Body text of success flag when feature is enabled',
	},
	successDisableDescription: {
		id: 'servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.success-disable-description',
		defaultMessage: 'You can enable this category again at any time.',
		description: 'Body text of success flag when feature is disabled',
	},
	successEnableDismiss: {
		id: 'servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.success-enable-dismiss',
		defaultMessage: 'Maybe later',
		description: 'Label used in dismiss button in success flag when feature is enabled',
	},
	successDisableDismiss: {
		id: 'servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.success-disable-dismiss',
		defaultMessage: 'Ok',
		description: 'Label used in dismiss button in success flag when feature is disabled',
	},
	successEnableAction: {
		id: 'servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.success-enable-action',
		defaultMessage: 'Add request types',
		description: 'Label used in action button in success flag when feature is enabled',
	},
	errorTitle: {
		id: 'servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.error-title',
		defaultMessage: `We couldn't {value, select, false {disable} true {enable} other {}} {feature, select,
            service_request {service requests}
            incident_management {incident management}
            problem_management {problem management}
            change_management {change management}
            post_incident_review {post-incident reviews}
            other {unknown}
        }`,
		description: 'Title text of error flag',
	},
	errorDesciption: {
		id: 'servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.error-desciption',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Body text of error flag',
	},
	errorDismiss: {
		id: 'servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.error-dismiss',
		defaultMessage: 'Dismiss',
		description: 'Label used in dismiss button in error flag',
	},
	errorAction: {
		id: 'servicedesk-itsm-features.controllers.practices.practice-features-controller.flags.error-action',
		defaultMessage: 'Refresh',
		description: 'Label used in action button in error flag',
	},
});
